import { keyframes } from 'styled-components';

export const fadeIn = keyframes`
0% {
  opacity: 0;
}
100% {
  opacity: 0.5;
}
`;
export const heightEffect = keyframes`
 from {height: 0; color: #1D1D1D;}
  to {height: 100%;}
`;
